import { Link } from "react-router-dom";

interface EmptyStateProps {
  title?: string;
  description?: string;
  onReset?: () => void;
  resetLabel?: string;
}

export default function EmptyState({
  title = "没有找到匹配的内容",
  description = "试试更换筛选条件，或换个关键词再搜索一次。",
  onReset,
  resetLabel = "重置筛选条件",
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-50 px-6 py-16 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-100 text-primary-500">
        <i className="ri-movie-2-line text-3xl"></i>
      </span>
      <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950">{title}</h3>
      <p className="mt-2 max-w-sm text-sm text-foreground-500">{description}</p>
      <div className="mt-6 flex flex-wrap justify-center gap-3">
        {onReset && (
          <button
            type="button"
            onClick={onReset}
            className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-refresh-line"></i>
            {resetLabel}
          </button>
        )}
        <Link
          to="/"
          className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-semibold text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
      </div>
    </div>
  );
}